import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IStylingUser } from './Entities';
import * as Actions from './actions/StylingUserActions';
import StylingUserList from './list/StylingUserList';
import { Translate } from '../../shared/LanguageService';
import { Button, FormGroup, Checkbox } from 'react-bootstrap';
import StylingUsersModal from './StylingUserModal';
import LogsModal from '../logs/LogsModal';
import ConfirmationModal from '../../components/common/ConfirmationModal';

class StylingUsersPage extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props);

        this.state = {
            showModal: false,
            showLogsModal: false,
            showDeleteConfirmation: false,
            deleteId: 0,
            stylingUserId: 0,
            showRemoved: false
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.editUser = this.editUser.bind(this);
        this.viewlogs = this.viewlogs.bind(this);
        this.deleteStylingUser = this.deleteStylingUser.bind(this);
        this.confirmedDeleteStylingUser = this.confirmedDeleteStylingUser.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
    }

    componentDidMount() {
        this.props.actions.getStylingUsers();
    }

    toggleModal() {
        if (!this.state.showModal) {
            this.setState({
                stylingUserId: 0,
                showModal: !this.state.showModal
            });
        } else {
            this.setState({ showModal: !this.state.showModal });
        }
    }

    editUser(id: number) {
        this.setState({ stylingUserId: id, showModal: true });
    }

    viewlogs(id: number) {
        this.setState({ stylingUserId: id, showLogsModal: true });
    }

    deleteStylingUser(id: number) {
        this.setState({
            showDeleteConfirmation: true,
            deleteId: id
        });
    }

    confirmedDeleteStylingUser(id: number) {
        const stylingUser = this.props.stylingUsers.find((stylingUser: IStylingUser) => {
            return stylingUser.id === id;
        });
        this.props.actions.delete(stylingUser.id);
    }

    renderLogModal() {
        if (this.state.showLogsModal) {
            return (
                <LogsModal
                    id={this.state.stylingUserId}
                    type="StylistUserId"
                    shouldShowModal={this.state.showLogsModal}
                    closeModal={() =>
                        this.setState({
                            showLogsModal: false,
                            stylingUserId: 0
                        })
                    }
                />
            );
        }
    }

    renderConfirmModal() {
        if (this.state.showDeleteConfirmation) {
            return (
                <ConfirmationModal
                    title={Translate('styling-user/modal/remove/confirmation/title')}
                    text={Translate('styling-user/modal/remove/confirmation/description')}
                    doButtonLabel={Translate('styling-user/list/row/button-label/delete')}
                    cancelButtonLabel={Translate('styling-user/list/row/button-label/abort')}
                    doButtonStyle="danger"
                    do={() => {
                        this.confirmedDeleteStylingUser(this.state.deleteId);
                        this.setState({
                            showDeleteConfirmation: false,
                            deleteId: 0
                        });
                    }}
                    closeModal={() => {
                        this.setState({
                            showDeleteConfirmation: false,
                            deleteId: 0
                        });
                    }}
                />
            );
        }
    }

    onCheckboxChange(e: any) {
        this.setState(currentState => ({showRemoved: !currentState.showRemoved}));
    }

    render() {
        return (
            <div>
                {this.renderLogModal()}
                {this.renderConfirmModal()}
                {this.state.showModal && (
                    <StylingUsersModal
                        showModal={this.state.showModal}
                        toggleModal={this.toggleModal}
                        stylingUserId={this.state.stylingUserId}
                    />
                )}
                <h1>{Translate('styling-user/page/title/styling-user')}</h1>
                <div className="row">
                    <div className="col-md-3 no-label">
                        <FormGroup>
                            <Checkbox
                                name="showRemoved"
                                checked={this.state.showRemoved}
                                onChange={this.onCheckboxChange}
                            >
                                <span>
                                    {Translate(
                                        'styling-user/show-removed-checkbox'
                                    )}
                                </span>
                            </Checkbox>
                        </FormGroup>
                    </div>
                    <Button
                        bsSize="large"
                        className="pull-right"
                        onClick={this.toggleModal}
                        bsStyle="success"
                    >
                        {Translate('styling-user/page/button-label/add-styling-user')}
                    </Button>
                </div>
                <div style={{ paddingTop: "16px" }}>
                    <StylingUserList
                        stylingUsers={this.props.stylingUsers}
                        editStylingUser={this.editUser}
                        viewlogs={this.viewlogs}
                        deleteStylingUser={this.deleteStylingUser}
                        user={this.props.user}
                        showRemoved={this.state.showRemoved}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    let stylingUsersFromState: IStylingUser[] = [...state.stylinguser.list];
    let sortedList = stylingUsersFromState.sort((a: IStylingUser, b: IStylingUser) => {
        return a.id - b.id;
    });

    return {
        stylingUsers: sortedList
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getStylingUsers: () => dispatch(Actions.getStylingUsers()),
            delete: (id: number) => dispatch(Actions.deleteStylingUser(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StylingUsersPage));
